import React from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils'
import Complete from '../../components/cart/Complete'

function CheckoutComplete() {
    return (
        <div>
            <Helmet>
                <title>Checkout Complete - {utils.siteName}</title>
                <meta name="description" content="Add your delivery information." />
                <meta name="robots" content="noindex" />
            </Helmet>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
                <div className="mb-6">
                    <h1 className="text-4xl font-black text-primary dark:text-secondary">
                        Checkout Complete
                    </h1>
                </div>
                <hr className='mb-6' />
                <Complete />
            </div>
        </div>
    )
}

export default CheckoutComplete